import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import SelectFieldForLoadCity from '../formFields/SelectFieldForLoadCity';
import SelectFieldForLoadState from '../formFields/SelectFieldForLoadState';
import DynamicFieldSet from '../formFields/DynamicFieldSet';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: 'add',
            formLayout: 'horizontal',
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getBankList()
        if(this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.setOrderId(id)
        }
    }

    __getBankList() {
        let bankList = this.props.bankList;
        let dataSource = [];

        if (bankList) {

            for (let i = 0; i < bankList.length; i++) {

                dataSource.push(
                    {label: bankList[i].title+' (موجودی '+(bankList[i].balance).toLocaleString(navigator.language, {minimumFractionDigits: 0})+' ریال)', value: bankList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    goBack(){
        this.props.history.goBack();
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">تسویه تکنسین</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <label style={{textAlign:'right'}}>
                            مبالغ نقدی به کدام حساب واریز شود:
                        </label>
                        <Row gutter={16}>

                            <Field
                                name="bank_account"
                                component={SelectField}
                                type="text"
                                label="حساب بانک"
                                placeholder="حساب بانک"
                                list={this.__getBankList()}
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton onClick={this.goBack.bind(this)} className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addsettle',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
